<template>
  <!--外层box-->
  <div
    ref="diagram"
    :class="!isFull ? 'diagram' : 'full'"
    @mouseenter="mouseEnter"
    @mouseout="mouseOut"
  >
    <div class="move-box" id="moveBox">
      <iframe
        ref="iframe"
        :style="`width:${w}%;height:${h}%;`"
        class="small"
        :src="src"
        frameborder="0"
      ></iframe>
    </div>
    <!--遮罩层 防止鼠标在iframe 中，无法触发滚轮事件-->
    <div class="mask"></div>

    <div class="menu" v-show="close">
      <div class="mini">
        <iframe
          ref="iframe2"
          style="width: 100%; height: 100%"
          :src="src"
          frameborder="0"
        ></iframe>
        <div id="clickBox" @click="miniClick"></div>
        <div id="handle" @mousedown="handleMouseDown">
          <div class="dragBtn"></div>
        </div>
      </div>
      <div class="scale" id="scale">
        <el-slider
          v-model="value"
          @change="sliderChange"
          :marks="marks"
          :show-tooltip="false"
        >
        </el-slider>
      </div>
    </div>
    <div class="oac" @click="oac" :style="oacStyle()">
      <div class="btnbg" :style="btnbgStyle()"></div>
    </div>

    <div class="btn row-center" v-if="isFull" @click="cancelFull">
      <img
        src="@/assets/img/退出全屏ICON.png"
        width="16rem"
        height="16rem"
        style="margin-right: 4rem"
        alt="取消全屏"
      />
      <span>取消全屏</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "Diagram",
  props: {
    src: String,
    isFull: Boolean,
  },
  data() {
    return {
      // 鼠标是否进入
      mouseInner: false,
      // 是否按住
      touched: false,

      // 外层宽高
      diagramWidth: 0,
      diagramHeight: 0,

      // 内层宽高
      iframeWidth: 0,
      iframeHeight: 0,

      w: 100,
      h: 100,
      max: 2000,
      min: 100,

      // 鼠标当前位置
      x: 0,
      y: 0,

      // 拖动开始结束坐标
      startX: 0,
      startY: 0,
      endX: 0,
      endY: 0,

      // 定位值
      left: 0,
      top: 0,

      // 偏移量
      frameOffsetX: 0,
      frameOffsetY: 0,

      // 缩放率
      step: 0.02,

      // 移动位置
      moveX: 0,
      moveY: 0,
      // 拖动变化量
      varX: 0,
      varY: 0,

      // 滑块
      value: 6,

      marks: {
        0: "100%",
        50: "1000%",
        100: "2000%",
      },

      close: true,

      // 小图的宽高
      width: 400,
      height: 200,

      // 相对于1440的比例
      size: 1,
    };
  },
  created() {
    this.size = parseFloat(document.documentElement.style.fontSize);
    this.width *= this.size;
    this.height *= this.size;
  },
  mounted() {
    document.getElementsByClassName("menu")[0].style.width = this.width + "px";
    document.getElementsByClassName("menu")[0].style.height =
      this.height + 60 * this.size + "px";
    document.getElementsByClassName("mini")[0].style.height =
      this.height + "px";
    document.getElementById("clickBox").style.height = this.height + "px";

    document.getElementsByClassName("oac")[0].style.width = this.width + "px";
    document.getElementsByClassName("oac")[0].style.bottom =
      this.height + 60 * this.size + "px";

    // // this.windowAddMouseWheel();
    let moveBox = document.getElementById("moveBox");
    let dragBox = document.getElementById("handle");

    let ww = (this.value / 100) * 2000;
    let hh = (this.value / 100) * 2000;

    if (ww >= this.min && ww <= this.max) {
      this.w = ww;
      this.h = hh;
    } else if (ww < this.min) {
      this.w = this.min;
      this.h = this.min;
    } else {
      this.w = this.max;
      this.h = this.max;
    }

    dragBox.style.width = (100 * 100) / this.w + "%";
    dragBox.style.height = (100 * 100) / this.h + "%";

    dragBox.style.left = 50 + "%";
    dragBox.style.top = 50 + "%";
    dragBox.style.transform = "translate(-50%,-50%)";
  },
  updated() {
    // 外层宽高
    let diagram = this.$refs.diagram;
    this.diagramWidth = diagram.clientWidth;
    this.diagramHeight = diagram.clientHeight;

    // iframe 宽高
    let iframe = this.$refs.iframe;
    this.iframeWidth = iframe.clientWidth;
    this.iframeHeight = iframe.clientHeight;
  },
  computed: {
    moveBoxStyle() {
      if (this.isFull) {
        return `
                        left:${this.moveX + this.varX}px;
                        top:${this.moveY + this.varY}px;
                    `;
      }

      return `
                    left:50%;
                    top:50%;
                    transform:translate(-50%, -50%);
                `;
    },
  },
  watch: {},
  methods: {
    clampNumber(num, a, b) {
      return Math.max(Math.min(num, Math.max(a, b)), Math.min(a, b));
    },
    oacStyle() {
      return this.close
        ? `bottom:${this.height + 60 * this.size}px`
        : `bottom:0`;
    },
    btnbgStyle() {
      return this.close ? `transform:scaleY(-1)` : `transform:scaleY(1)`;
    },
    oac() {
      this.close = !this.close;
    },
    miniClick(e) {
      let dragBox = document.getElementById("handle");
      let moveBox = document.getElementById("moveBox");
      let left = e.offsetX;
      let top = e.offsetY;

      if (left < dragBox.clientWidth / 2 + 2)
        left = dragBox.clientWidth / 2 + 2;
      if (left > this.width - (dragBox.clientWidth / 2 + 2))
        left = this.width - (dragBox.clientWidth / 2 + 2);
      if (top < dragBox.clientHeight / 2 + 2)
        top = dragBox.clientHeight / 2 + 2;
      if (top > this.height - (dragBox.clientHeight / 2 + 2))
        top = this.height - (dragBox.clientHeight / 2 + 2);

      dragBox.style.left = left + "px";
      dragBox.style.top = top + "px";

      dragBox.style.width = (100 * 100) / this.w + "%";
      dragBox.style.height = (100 * 100) / this.h + "%";

      let changeLeft = left - dragBox.clientWidth / 2 - 2;
      let changeTop = top - dragBox.clientHeight / 2 - 2;

      moveBox.style.left =
        (moveBox.clientWidth * this.w) / 200 -
        changeLeft * ((moveBox.clientWidth * this.w) / (this.width * 100)) +
        "px";
      moveBox.style.top =
        (moveBox.clientHeight * this.h) / 200 -
        changeTop * ((moveBox.clientHeight * this.w) / (this.height * 100)) +
        "px";
    },
    sliderChange() {
      let moveBox = document.getElementById("moveBox");
      let dragBox = document.getElementById("handle");

      let ww = (this.value / 100) * 2000;
      let hh = (this.value / 100) * 2000;

      if (ww >= this.min && ww <= this.max) {
        this.w = ww;
        this.h = hh;
      } else if (ww < this.min) {
        this.w = this.min;
        this.h = this.min;
      } else {
        this.w = this.max;
        this.h = this.max;
      }

      dragBox.style.width = (100 * 100) / this.w + "%";
      dragBox.style.height = (100 * 100) / this.h + "%";

      let left = dragBox.offsetLeft;
      let top = dragBox.offsetTop;

      if (left < dragBox.clientWidth / 2 + 2)
        left = dragBox.clientWidth / 2 + 2;
      if (left > this.width - (dragBox.clientWidth / 2 + 2))
        left = this.width - (dragBox.clientWidth / 2 + 2);
      if (top < dragBox.clientHeight / 2 + 2)
        top = dragBox.clientHeight / 2 + 2;
      if (top > this.height - (dragBox.clientHeight / 2 + 2))
        top = this.height - (dragBox.clientHeight / 2 + 2);

      dragBox.style.left = left + "px";
      dragBox.style.top = top + "px";

      if (this.value !== 0) {
        let changeLeft = left - dragBox.clientWidth / 2 - 2;
        let changeTop = top - dragBox.clientHeight / 2 - 2;

        moveBox.style.left =
          (moveBox.clientWidth * this.w) / 200 -
          changeLeft * ((moveBox.clientWidth * this.w) / (this.width * 100)) +
          "px";
        moveBox.style.top =
          (moveBox.clientHeight * this.h) / 200 -
          changeTop * ((moveBox.clientHeight * this.w) / (this.height * 100)) +
          "px";
      } else {
        moveBox.style.left = 50 + "%";
        moveBox.style.top = 50 + "%";
      }
    },
    reset() {
      this.w = 100;
      this.h = 100;
      // 鼠标当前位置
      this.x = 0;
      this.y = 0;

      // 拖动开始结束坐标
      this.startX = 0;
      this.startY = 0;
      this.endX = 0;
      this.endY = 0;

      // 定位值
      this.left = 0;
      this.top = 0;

      // 偏移量
      this.frameOffsetX = 0;
      this.frameOffsetY = 0;

      // 移动位置
      this.moveX = 0;
      this.moveY = 0;
      // 拖动变化量
      this.varX = 0;
      this.varY = 0;

      this.value = 0;
      let dragBox = document.getElementById("handle");
      dragBox.style.width = 100 + "%";
      dragBox.style.height = 100 + "%";

      let left = dragBox.offsetLeft;
      let top = dragBox.offsetTop;

      if (left < dragBox.clientWidth / 2 + 2)
        left = dragBox.clientWidth / 2 + 2;
      if (left > this.width - (dragBox.clientWidth / 2 + 2))
        left = this.width - (dragBox.clientWidth / 2 + 2);
      if (top < dragBox.clientHeight / 2 + 2)
        top = dragBox.clientHeight / 2 + 2;
      if (top > this.height - (dragBox.clientHeight / 2 + 2))
        top = this.height - (dragBox.clientHeight / 2 + 2);

      dragBox.style.left = 50 + "%";
      dragBox.style.top = 50 + "%";
      dragBox.style.transform = "translate(-50%,-50%)";

      let moveBox = document.getElementById("moveBox");

      moveBox.style.left = 50 + "%";
      moveBox.style.top = 50 + "%";
      moveBox.style.transform = "translate(-50%,-50%)";
    },
    full() {
      this.isFull = true;
      this.$emit("onFull");
      this.width = 400 * this.size;
      this.height =
        (document.documentElement.clientHeight /
          document.documentElement.clientWidth) *
        this.width;
      document.getElementsByClassName("menu")[0].style.width =
        this.width + "px";
      document.getElementsByClassName("menu")[0].style.height =
        this.height + 60 * this.size + "px";
      document.getElementsByClassName("mini")[0].style.height =
        this.height + "px";
      document.getElementById("clickBox").style.height = this.height + "px";

      document.getElementById("handle").style.top = "50%";

      this.close = true;
      document.getElementsByClassName("oac")[0].style.width = this.width + "px";
      document.getElementsByClassName("oac")[0].style.bottom =
        this.height + 60 * this.size + "px";
    },
    cancelFull() {
      this.isFull = false;
      this.$emit("onCancelFull");

      this.width = 400 * this.size;
      this.height = 200 * this.size;
      document.getElementsByClassName("menu")[0].style.width =
        this.width + "px";
      document.getElementsByClassName("menu")[0].style.height =
        this.height + 60 * this.size + "px";
      document.getElementsByClassName("mini")[0].style.height =
        this.height + "px";
      document.getElementById("clickBox").style.height = this.height + "px";

      document.getElementById("handle").style.top = "50%";

      this.close = true;
      document.getElementsByClassName("oac")[0].style.width = this.width + "px";
      document.getElementsByClassName("oac")[0].style.bottom =
        this.height + 60 * this.size + "px";
      //   this.reset();
    },
    framePosition() {
      // 计算iframe 的定位
      this.left = this.x;
      this.top = this.y;

      // 偏移量
      this.frameOffsetX = (this.x / this.diagramWidth) * this.iframeWidth;
      this.frameOffsetY = (this.y / this.diagramHeight) * this.iframeHeight;
    },
    add() {
      if (this.mouseInner && this.w < this.max) {
        this.w *= 1 + this.step;
        this.h *= 1 + this.step;

        if (this.w > this.max) {
          this.w = this.max;
          this.h = this.max;
        }

        // this.framePosition()
      }
    },
    subtract() {
      if (this.mouseInner && this.w > this.min) {
        this.w *= 1 - this.step;
        this.h *= 1 - this.step;

        if (this.w < this.min) {
          this.w = this.min;
          this.h = this.min;
        }
        // this.framePosition()
      }
    },
    mouseUp(e) {
      this.touched = false;

      // 记录结束位置
      this.endX = e.offsetX;
      this.endY = e.offsetY;

      // 累加变化量
      this.moveX += this.varX;
      this.moveY += this.varY;

      // 清除变化量
      this.varX = 0;
      this.varY = 0;
    },
    mouseDown(e) {
      this.touched = true;

      // 记录开始位置
      this.startX = e.offsetX;
      this.startY = e.offsetY;
    },
    mouseMove(e) {
      this.mouseEnter(null);
      this.x = e.offsetX;
      this.y = e.offsetY;

      if (this.touched) {
        // 变化量
        this.varX = e.offsetX - this.startX;
        this.varY = e.offsetY - this.startY;
      }
    },

    windowAddMouseWheel() {
      var scrollFunc = (e) => {
        e = e || window.event;
        if (e.wheelDelta) {
          //判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) {
            //当滑轮向上滚动时
            this.up(e);
          }
          if (e.wheelDelta < 0) {
            //当滑轮向下滚动时
            this.down(e);
          }
        } else if (e.detail) {
          //Firefox滑轮事件
          if (e.detail > 0) {
            //当滑轮向上滚动时
            this.up(e);
          }
          if (e.detail < 0) {
            //当滑轮向下滚动时
            this.down(e);
          }
        }
      };
      //给页面绑定滑轮滚动事件
      if (document.addEventListener) {
        document.addEventListener("DOMMouseScroll", scrollFunc, false);
      }
      //滚动滑轮触发scrollFunc方法
      window.onmousewheel = document.onmousewheel = scrollFunc;
    },
    mouseEnter() {
      this.mouseInner = true;
    },
    mouseOut() {
      this.mouseInner = false;
    },
    down() {
      this.subtract();
    },
    up() {
      this.add();
    },

    handleMouseDown(e) {
      let dragBox = document.getElementById("handle");
      let moveBox = document.getElementById("moveBox");
      //算出鼠标相对元素的位置
      let disX = e.clientX - dragBox.offsetLeft;
      let disY = e.clientY - dragBox.offsetTop;
      dragBox.onmousemove = (e) => {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        let left = e.clientX - disX;
        let top = e.clientY - disY;

        if (left < dragBox.clientWidth / 2 + 2)
          left = dragBox.clientWidth / 2 + 2;
        if (left > this.width - (dragBox.clientWidth / 2 + 2))
          left = this.width - (dragBox.clientWidth / 2 + 2);
        if (top < dragBox.clientHeight / 2 + 2)
          top = dragBox.clientHeight / 2 + 2;
        if (top > this.height - (dragBox.clientHeight / 2 + 2))
          top = this.height - (dragBox.clientHeight / 2 + 2);

        //移动当前元素
        dragBox.style.left = left + "px";
        dragBox.style.top = top + "px";

        let changeLeft = left - dragBox.clientWidth / 2 - 2;
        let changeTop = top - dragBox.clientHeight / 2 - 2;

        moveBox.style.left =
          (moveBox.clientWidth * this.w) / 200 -
          changeLeft * ((moveBox.clientWidth * this.w) / (this.width * 100)) +
          "px";
        moveBox.style.top =
          (moveBox.clientHeight * this.h) / 200 -
          changeTop * ((moveBox.clientHeight * this.w) / (this.height * 100)) +
          "px";
      };
      dragBox.onmouseup = (e) => {
        dragBox.onmousemove = null;
        dragBox.onmouseup = null;
        dragBox.onmousedown = null;
      };
      dragBox.onmouseout = (e) => {
        dragBox.onmousemove = null;
        dragBox.onmouseup = null;
        dragBox.onmousedown = null;
      };
    },
  },
};
</script>

<style scoped lang="less">
.full {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
}

.diagram {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: "100vw";
  height: "100vh";
  z-index: 9999;
  background-color: #fff;
}

.move-box {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #fff;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.small,
.mask {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  /*transition: all 0.1s;*/
}

.mask {
  z-index: 98;
  width: 100%;
  height: 100%;
}

.btn {
  width: 150rem;
  height: 56rem;
  position: absolute;
  top: 14rem;
  right: 36rem;
  z-index: 9999;
  background-image: url(../assets/img/diagrambtn-bg.png);
  color: #333333;
  font-size: 14rem;
  background-size: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  span {
    margin-top: -2rem;
  }

  img {
    width: 16rem;
    height: 16rem;
    // margin-right: 70 / 1920 * 100vw;
    margin-top: -2rem;
  }
}

.oac {
  width: 400px;
  height: 40px;
  position: absolute;
  right: 0;
  bottom: 260px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 10000;

  .btnbg {
    height: 20px;
    width: 52px;
    background-image: url(../assets/img/jiantou.png);
    background-size: 100% 100%;
  }
}

.menu {
  background: #fff;
  position: absolute;
  right: 0;
  bottom: 0;
  z-index: 9999;
  box-shadow: 0px 0px 40rem 0px rgba(0, 43, 102, 0.28);

  .mini {
    width: 100%;
    position: relative;

    #clickBox {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }

    #handle {
      cursor: pointer;
      width: 100%;
      height: 100%;
      border: 2px solid #0d94ff;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .dragBtn {
        width: 25%;
        height: 50%;
        transform: translate(150%, 50%);
        background: url(../assets/img/drag.png);
        background-size: 100% 100%;
      }
    }
  }

  .scale {
    width: 100%;
    height: 60rem;
    background: #fff;
    padding: 0 30rem;
  }
}
</style>